import { LABEL } from '../../theme/constants';
import { Put } from './authorizedRequest';

async function singleReleaseActionCall(obj) {
  let container = obj.containers[0];
  let isRelease = obj.actionType.toUpperCase() === LABEL.RELEASE_LABEL;

  const url = `/${
    container.portLoCode
  }/containers/${container.equipmentNumber.trim()}/import/commercial-release/`;
  const body = {
    releaseIdentification: container.releaseIdentification.trim(),
    releaseOrderReference: container.releaseOrderReference,
    equipmentNumber: container.equipmentNumber.trim(),
    releaseId: container.releaseId,
    equipmentType: container.equipmentType,
    emptyReturnReference: container.emptyReturnReference,
    billOfLadingNumbers: isRelease
      ? container.billOfLadingNumbers.map((bl) => (bl = bl.blNumber.trim()))
      : container.billOfLadingNumbers,
    portLoCode: container.portLoCode,
    terminalCode: container.terminalCode,
    actionType: obj.actionType,
    carrier: {
      identificationType: 'NxtEntityId',
      identificationCode: isRelease ? obj.nxtEntityId : container.originatorNxtEntityId,
    },
    releaseTo: {
      identificationType: 'NxtEntityId',
      identificationCode: isRelease ? obj.nxtEntityId : container.releaseToNxtEntityId,
    },
    releaseDateTimeUtc: container.releaseDateTimeUtc,
    expirationDateTimeUtc: container.expirationDateTimeUtc,
    equipmentSupplier: container.releaseRightContextData?.equipmentSupplier,
    equipmentStatus: container.releaseRightContextData?.equipmentStatus,
    equipmentOperator: container.releaseRightContextData?.equipmentOperator,
    fullEmptyIndicator: container.releaseRightContextData?.fullEmptyIndicator,
    isCarrierHaulage:
      container.releaseRightContextData?.isCarrierHaulage === true ||
      container.releaseRightContextData?.isCarrierHaulage === 'true',
    vesselCallSign: container.releaseRightContextData?.vesselCallSign,
    vesselName: container.releaseRightContextData?.vesselName,
    imoNumber: container.releaseRightContextData?.imoNumber,
    stayNumber: container.stayNumber,
    voyageNumber: container.releaseRightContextData?.voyageNumber,
    reason: obj.reason,
  };

  const request = await Put(url, body);
  const response = await fetch(request);

  if (!response.ok) {
    let err;
    try {
      err = await response.json();
    } catch {
      throw new Error(response.statusText);
    }
    throw err;
  }

  let responseJson = response.json();

  return responseJson;
}

async function multipleReleaseActionCall(obj) {
  let releaseRightIdentifiers = [];

  let isRelease = obj.actionType.toUpperCase() === LABEL.RELEASE_LABEL;
  obj.containers.forEach((container) => {
    releaseRightIdentifiers.push({
      billOfLadingNumbers: isRelease
        ? container.billOfLadingNumbers.map((bl) => bl.blNumber.trim())
        : container.billOfLadingNumbers,
      equipmentNumber: container.equipmentNumber.trim(),
      releaseIdentification: container.releaseIdentification.trim(),
      terminalCode: container.terminalCode,
      portLoCode: container.portLoCode,
    });
  });
  const portLoCode = obj.containers[0].portLoCode;
  const url = `/${portLoCode}/containers/import/commercial-release/`;
  const body = {
    actionType: obj.actionType,
    releaseRights: releaseRightIdentifiers,
  };

  const request = await Put(url, body);
  const response = await fetch(request);

  if (!response.ok) {
    let err;
    try {
      err = await response.json();
    } catch {
      throw new Error(response.statusText);
    }
    throw err;
  }

  let responseJson = response.json();

  return responseJson;
}

export async function submitReleaseAction(obj) {
  let multipleContainers = obj.containers.length > 1;

  if (!multipleContainers) {
    singleReleaseActionCall(obj).then((response) => {
      return response;
    });
  } else {
    multipleReleaseActionCall(obj).then((response) => {
      return response;
    });
  }
}
